// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const GuildAtCapacityModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Community at Capacity`}
			description={t`This community has reached its maximum member limit and is not accepting new members at this time.`}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
